/**
 * en-GB messages added by Phase 4 task S53 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s53EnGB = {
    'error.onboarding_site_first': 'Create your first site before adding groups.',
};
//# sourceMappingURL=s53.js.map